import RecommendationByGradePage from './pages/recommendationsByGrade.svelte';
import RecommendationPage from './pages/recommendation.svelte';
import ToolsPage from './pages/tools.svelte';
import AboutPage from './pages/about.svelte';
import GradeDefinitionsPage from './pages/gradeDefinitions.svelte';
import ByTopicPage from './pages/byTopic.svelte';
import TopicPage from './pages/topic.svelte';
import DefaultPage from './pages/default.svelte';
import MyBookmarksPage from './pages/myBookmarks.svelte';

var routes = [
  {
    path: '/',
    component: RecommendationByGradePage,
    master: true,
    detailRoutes: [
      {
        path: '/recommendation/:id',
        component: RecommendationPage,
      },
    ]
  },
  {
    path: '/bytopic',
    component: ByTopicPage,
    master: true,
    detailRoutes: [
      {
        path: '/topic/:id',
        component: TopicPage,
      },
    ]
  },
  {
    path: '/bygrade',
    component: RecommendationByGradePage,
    master: true,
    detailRoutes: [
      {
        path: '/recommendation/:id',
        component: RecommendationPage,
      },
    ]
  },
  {
    path: '/about',
    component: AboutPage,
  },
  {
    path: '/tools',
    component: ToolsPage,
  },
  {
    path: '/grade-definitions',
    component: GradeDefinitionsPage,
  },
  {
    path: '/mybookmarks',
    component: MyBookmarksPage,
  },
  // Default route, match to all pages (e.g. 404 page)
  {
    path: '(.*)',
    component: DefaultPage,
  },
];

export default routes;